import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import { getTrackerPodiumPath } from "../../../Common/utils/cloudinary";
import Media from "../../media";

const TrackerPodium = () => {
  const { configData, cloudinaryBase, envVersion, currentSeasonYear } =
    useCloudinaryData();

  const flagImagePath = getTrackerPodiumPath(
    configData,
    cloudinaryBase,
    envVersion,
    currentSeasonYear
  );
  return <Media imgSrc={flagImagePath} imgAlt="Tracker Checkboard Flag" />;
};

export default TrackerPodium;
